class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    //Custom querySelector back-ups added because the mega-menu where changed from details element to normal divs -N.T-
    this.mainDetailsToggle = this.querySelector('details');
    
    if (!this.mainDetailsToggle) this.mainDetailsToggle = this.querySelector('div.details');
    
    this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling;
    if (!this.content) this.content = this.mainDetailsToggle.querySelector('div.summary')?.nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    //Added a querySelector for fake summary that are actually div (used for the mega-menu because normal details element act weirdly with open transitions) -N.T-
    let summary= this.mainDetailsToggle.querySelector('summary')
    if (!summary) summary= this.mainDetailsToggle.querySelector('div.summary')
    summary?.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
